import type { RouteRecordRaw } from 'vue-router';

// The check-in flow's strings live in the GLOBAL bundle (src/i18n/*/checkin.ts) because the
// flow (CheckinFlow / ListAppointments / VerifyEditAppointment) is reused off-route — e.g. the
// customer-management dialog. A route-scoped bundle would render raw keys there, so this screen
// declares no `meta.i18n`.
export const customerCheckinRoutes = {
  name: 'customer-checkin',
  path: 'customer-checkin',
  component: () => import('./CustomerCheckin.vue'),
} satisfies RouteRecordRaw;
